import {
  ADMINISTRATOR_KEY,
  PERMISSIONS,
  PERMISSION_KEYS,
  ROLE_FILTERS,
  SUMMARY_VISIBLE_PERMISSIONS,
  USER_ROLES,
} from './administrationConstants'

export function getUserRole(user) {
  if (user.isSuperAdministrator) return USER_ROLES.SUPER_ADMINISTRATOR
  if (user.isAdministrator) return USER_ROLES.ADMINISTRATOR
  return USER_ROLES.SUPPORT
}

const ROLE_FILTER_MATCHERS = {
  [ROLE_FILTERS.ALL]: () => true,
  [ROLE_FILTERS.SUPER_ADMINISTRATORS]: (user) =>
    getUserRole(user) === USER_ROLES.SUPER_ADMINISTRATOR,
  [ROLE_FILTERS.ADMINISTRATORS]: (user) => getUserRole(user) === USER_ROLES.ADMINISTRATOR,
  [ROLE_FILTERS.SUPPORT]: (user) => getUserRole(user) === USER_ROLES.SUPPORT,
}

export function filterUsers(users, { search, role }) {
  const normalizedSearch = search.trim().toLowerCase()
  const matchesRole = ROLE_FILTER_MATCHERS[role] ?? ROLE_FILTER_MATCHERS[ROLE_FILTERS.ALL]

  return users.filter(
    (user) =>
      matchesRole(user) &&
      (normalizedSearch === '' ||
        (user.name ?? '').toLowerCase().includes(normalizedSearch) ||
        (user.login ?? '').toLowerCase().includes(normalizedSearch)),
  )
}

export function getGrantedPermissions(user) {
  return PERMISSIONS.filter((permission) => user[permission.key])
}

export function summarizePermissions(user) {
  const granted = getGrantedPermissions(user)
  if (granted.length === 0) return 'Somente telas sem restrição'
  if (granted.length === PERMISSIONS.length) return 'Acesso total'

  const visible = granted
    .slice(0, SUMMARY_VISIBLE_PERMISSIONS)
    .map((permission) => permission.label)
  const hidden = granted.length - visible.length
  return hidden > 0 ? `${visible.join(' · ')} · +${hidden}` : visible.join(' · ')
}

export function pickEditableValues(user) {
  return [...PERMISSION_KEYS, ADMINISTRATOR_KEY].reduce(
    (values, key) => ({ ...values, [key]: Boolean(user[key]) }),
    {},
  )
}

export function diffPermissions(original, draft) {
  return Object.fromEntries(Object.entries(draft).filter(([key, value]) => original[key] !== value))
}

export function canEditUser(editor, target) {
  return editor.isSuperAdministrator || !target.isSuperAdministrator
}
